// import { ipcRenderer } from "electron";
// import { useEffect } from "react";

import { Button, Card } from "@arco-design/web-react";
import { observer } from "mobx-react-lite";
import ClientTabs from "@/stores/clientTabStore";

const Log = () => {
  // 监听日志消息

  return (
    <div>
      <Card
        title="日志列表"
        bordered={false}
        style={{ height: "calc(100vh - 152px)", overflowY: "auto" }}>
        {ClientTabs.logList.map((item, index) => (
          <div
            key={index}
            style={{ whiteSpace: "pre-wrap", overflow: "hidden" }}>
            {item}
          </div>
        ))}
      </Card>
    </div>
  );
};

export default observer(Log);
